import { Building2, Calendar, Globe, Mail, Phone } from 'lucide-react';
import { Button } from 'components/ui/button';
import { OrganizationData } from '../../services/organization-service';
import { useTranslation } from 'react-i18next';

interface ExpandedOrganizationDetailsProps {
    organization: OrganizationData;
    onEdit: (organization: OrganizationData) => void;
    onDeactivate: (organization: OrganizationData) => void;
    onActivate: (organization: OrganizationData) => void;
}

export function ExpandedOrganizationDetails({
    organization,
    onEdit,
}: Readonly<ExpandedOrganizationDetailsProps>) {
    const { t } = useTranslation();

    return (
        <div className="p-4 space-y-4 bg-muted/50 rounded-lg">
            <div className="space-y-3">
                <div className="flex items-center space-x-3">
                    <Mail className="w-4 h-4 text-muted-foreground" />
                    <div>
                        <p className="text-sm font-medium">{t('EMAIL')}</p>
                        <p className="text-sm text-muted-foreground">{organization.email}</p>
                    </div>
                </div>

                {/* <div className="flex items-center space-x-3">
                    <Building2 className="w-4 h-4 text-muted-foreground" />
                    <div>
                        <p className="text-sm font-medium">{t('ORGANIZATION_CODE')}</p>
                        <p className="text-sm text-muted-foreground">{organization.code}</p>
                    </div>
                </div> */}

                {organization.phoneNumber && (
                    <div className="flex items-center space-x-3">
                        <Phone className="w-4 h-4 text-muted-foreground" />
                        <div>
                            <p className="text-sm font-medium">{t('PHONE')}</p>
                            <p className="text-sm text-muted-foreground">{organization.phoneNumber}</p>
                        </div>
                    </div>
                )}

                {organization.websiteUrl && (
                    <div className="flex items-center space-x-3">
                        <Globe className="w-4 h-4 text-muted-foreground" />
                        <div>
                            <p className="text-sm font-medium">{t('WEBSITE')}</p>
                            <p className="text-sm text-muted-foreground">
                                <a
                                    href={organization.websiteUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline"
                                >
                                    {organization.websiteUrl}
                                </a>
                            </p>
                        </div>
                    </div>
                )}

                {organization.address && (
                    <div className="flex items-start space-x-3">
                        <Building2 className="w-4 h-4 text-muted-foreground mt-0.5" />
                        <div>
                            <p className="text-sm font-medium">{t('ADDRESS')}</p>
                            <p className="text-sm text-muted-foreground">{organization.address}</p>
                        </div>
                    </div>
                )}

                <div className="flex items-center space-x-3">
                    <Calendar className="w-4 h-4 text-muted-foreground" />
                    <div>
                        <p className="text-sm font-medium">{t('CREATED_DATE')}</p>
                        <p className="text-sm text-muted-foreground">
                            {new Date(organization.createdDate).toLocaleDateString()}
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex space-x-2 pt-2">
                <Button size="sm" onClick={() => onEdit(organization)} className="flex-1">
                    {t('EDIT')}
                </Button>
            </div>
        </div>
    );
} 